import { createAction, createAsyncThunk, Dispatch } from "@reduxjs/toolkit";
import { ApiPessoas, PessoasQueryParams } from "service/api/pessoa/ApiPessoas";
import { RootState } from "store/store";
import { ErrosUtils } from "util/ErrosUtils";


class TimerAction {
  static readonly finalizar = createAction<number>('Pessoas/timer/finalizar');

  static readonly despacharTimer = (timerCriado: number, state: RootState, dispatch: Dispatch) => {
    const { timer: timerRegistrado, pessoas } = state.pessoas;

    const alguemNaFila = pessoas.naFila.size !== 0 || pessoas.emRequisicao.size !== 0;
    const segundoTimerDisparado = timerRegistrado !== undefined && timerRegistrado !== timerCriado;
    
    // console.log(`Timer - ${timerCriado}`, "Tem gente na fila?", alguemNaFila);
    // console.log(`Timer - ${timerCriado}`, "Aqui é um segundo timer disparado?", segundoTimerDisparado);

    if (segundoTimerDisparado) {
      // console.log(`Timer - ${timerCriado}`, "Finalizado: Timer redundante")
      window.clearInterval(timerCriado);

    } else if (!alguemNaFila) {
      // console.log(`Timer - ${timerCriado}`, "Finalizado: Ninguém na fila")
      window.clearInterval(timerCriado);
      dispatch(PessoasAction.timer.finalizar(timerCriado));

    } else {
      // console.log(`Timer - ${timerCriado}`, "Chamar timer, ó")
      dispatch(PessoasAction._carregar(timerCriado) as any);
    }
  }
}


export class PessoasAction {
  public static readonly carregar = (idInstitucional: string) => async (dispatch: Dispatch, getState: () => RootState) => {
    const { pessoas, timer: timerRegistrado } = getState().pessoas;

    const naoSolicitar = pessoas.naFila.has(idInstitucional)
                      || pessoas.emRequisicao.has(idInstitucional)
                      || pessoas.carregadas.has(idInstitucional);

    if (naoSolicitar) {
      return;
    }

    await dispatch(PessoasAction.adicionarNaFila(idInstitucional));
    
    if (timerRegistrado === undefined) {
      const timerCriado = window.setInterval(
        () => PessoasAction.timer.despacharTimer(timerCriado, getState(), dispatch),
        1.5 * 1000
      );
    }
  };

  public static readonly adicionarNaFila = createAction<string>('Pessoas/adicionarNaFila');

  static readonly _carregar = createAsyncThunk(
    'Pessoas/carregar',
    async (timerSolicitante: number, {rejectWithValue, getState}) => {

      const { pessoas } = getState() as RootState;
      const { pessoas: elementos, timer: timerRegistrado } = pessoas;

      console.info(`Timer - ${timerSolicitante}`, "Timer em execução")

      if (timerSolicitante !== timerRegistrado) {
        console.error(`Timer - ${timerSolicitante}`, "Abrindo mais de um timer solicitante!", timerSolicitante, timerRegistrado);
        console.error(`Timer - ${timerSolicitante}`, "Fechando manualmente timer:", timerSolicitante);
        window.clearInterval(timerSolicitante);
      }

      if (elementos.emRequisicao.size === 0) {
        console.error(`Timer - ${timerSolicitante}`, "Ninguém para carregar")
        return;
      }

      const query: PessoasQueryParams = {
        idInstitucional: [...elementos.emRequisicao as any]
      }

      try {
        return await ApiPessoas.getPessoas(query);
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  );

  static readonly timer = TimerAction;
}